import { AxiosInstance } from 'axios';

import {
  AgentsAPIApiFactory,
  RunbooksAPIApiFactory,
  IntegrationsAPIApiFactory,
  RunbookReportsAPIApiFactory,
  RunbookRunsAPIApiFactory,
  RunbookActivitiesAPIApiFactory,
  ModelsAPIApiFactory,
  ConfigsAPIApiFactory,
} from '@cast/openapi-apa';

import { AXIOS_CONFIGURATION } from '../constants';

export const ApaApiFactory = (client: AxiosInstance) => {
  const agentsGeneratedApi = AgentsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const integrationsGeneratedApi = IntegrationsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const runbooksGeneratedApi = RunbooksAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const runbookReportsGeneratedApi = RunbookReportsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const runbookRunsGeneratedApi = RunbookRunsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const runbookActivitiesGeneratedApi = RunbookActivitiesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const modelsGeneratedApi = ModelsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const configsGeneratedApi = ConfigsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getAgents: agentsGeneratedApi.agentsAPIListAgents,
    getRunbookOperatorInstallScript:
      agentsGeneratedApi.agentsAPIGetInstallCommand,
    listIntegrations:
      integrationsGeneratedApi.integrationsAPIListIntegrationsOrganization,
    createIntegration:
      integrationsGeneratedApi.integrationsAPICreateIntegration,
    deleteIntegration:
      integrationsGeneratedApi.integrationsAPIDeleteIntegrationOrganization,
    deleteRunbook: runbooksGeneratedApi.runbooksAPIDeleteRunbook,
    getRunbooks: runbooksGeneratedApi.runbooksAPIListRunbooksOrganization,
    createRunbook: runbooksGeneratedApi.runbooksAPICreateRunbook,
    updateRunbook: runbooksGeneratedApi.runbooksAPIUpdateRunbook,
    getImageVulnerabilityReport:
      runbookReportsGeneratedApi.runbookReportsAPIGetImageVulnerabilityRemediationReport,
    getDBOReport:
      runbookReportsGeneratedApi.runbookReportsAPIGetDatabaseOptimizerReport,
    getWoopReport:
      runbookReportsGeneratedApi.runbookReportsAPIGetWOOPRecommendationsSyncReport,
    getComplianceFixReport:
      runbookReportsGeneratedApi.runbookReportsAPIGetComplianceFixReport,
    getRunbookRuns: runbookRunsGeneratedApi.runbookRunsAPIListRunbookRuns,
    createRunbookRun: runbookRunsGeneratedApi.runbookRunsAPICreateRunbookRun,
    updateRunbookRun: runbookRunsGeneratedApi.runbookRunsAPIUpdateRunbookRun,
    getRunbookActivities:
      runbookActivitiesGeneratedApi.runbookActivitiesAPIListRunbookActivitiesCluster,
    getModels: modelsGeneratedApi.modelsAPIGetModels,
    listIntegrationRepositories:
      integrationsGeneratedApi.integrationsAPIListIntegrationRepositories,
    getConfig: configsGeneratedApi.configsAPIGetConfig,
    updateConfig: configsGeneratedApi.configsAPIUpdateConfig,
  };
};
